import { Root } from './components/Root';

export const NotificationCard = {
  Root,
};
